export default __webpack_public_path__ + "static/media/img_3_thumb.ff754146.JPG";